export const cookiesAccept = () => {
  console.log("ACCEPTED");
  return { type: "COOKIES_ACCEPTED" };
};

export const cookiesDeclined = () => {
  return { type: "COOKIES_DECLINED" };
};



// WEBPACK FOOTER //
// ./src/store/actions/cookieActions.tsx